import { render, staticRenderFns } from "./Loginphone.vue?vue&type=template&id=667f88b7&scoped=true&"
import script from "./Loginphone.vue?vue&type=script&lang=js&"
export * from "./Loginphone.vue?vue&type=script&lang=js&"
import style0 from "./Loginphone.vue?vue&type=style&index=0&id=667f88b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f88b7",
  null
  
)

export default component.exports